import { FieldContext, useField } from 'vee-validate';
import { Ref } from 'vue';
import { ValidationError } from 'yup';
import * as yup from 'yup';

export type ValidationBaseSchemaType = { fields: { [id: string]: any }; describe: () => any };
export type ValidationBaseFormType = { errors: { [id: string]: any } };
export type ValidationField = {
  key: string;
  label: string;
  path: string;
  field: FieldContext;
  value: any;
  getValue: <T>() => Ref<T>;
};

export type ValidationFieldsType<SCHEMA_TYPE extends ValidationBaseSchemaType> = {
  [Property in keyof SCHEMA_TYPE['fields']]: ValidationField;
};

export function validationFields<SCHEMA_TYPE extends ValidationBaseSchemaType>(
  schema: SCHEMA_TYPE,
  formPath: string = undefined
): ValidationFieldsType<SCHEMA_TYPE> {
  const result: any = {};
  Object.keys(schema.fields).forEach((currentKey) => {
    const prefix = formPath ? `${formPath}.` : '';
    const field = useField(prefix + currentKey);
    result[currentKey] = {
      key: currentKey,
      label: schema.fields[currentKey]?.describe().label,
      path: prefix + currentKey,

      field: field,
      value: field.value,
      getValue: <T>() => field.value as Ref<T>
    };
  });
  return result;
}

// for schema describing a single field
export function validationField(schema: yup.Schema, formPath: string = undefined): ValidationField {
  const currentKey = formPath || '';
  const field = useField(currentKey);
  return {
    key: currentKey,
    label: schema.describe().label,
    path: currentKey,

    field: field,
    value: field.value,
    getValue: <T>() => field.value as Ref<T>
  };
}

export async function validateYup(value: any, schema: yup.Schema): Promise<{ valid: boolean; errors?: string[] }> {
  if (!schema) {
    return {
      valid: true
    };
  }

  try {
    await schema.validate(value);
    return {
      valid: true
    };
  } catch (e) {
    const validationError = e as ValidationError;
    return {
      valid: false,
      errors: validationError.errors
    };
  }
}
